var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgSaveIcon(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 22.748,
    height: 22.748,
    viewBox: "0 0 22.748 22.748",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Path_3572",
    "data-name": "Path 3572",
    d: "M4.533,25.148A2.133,2.133,0,0,1,2.4,23.015V4.533A2.133,2.133,0,0,1,4.533,2.4H18.011a1.789,1.789,0,0,1,1.2.467L24.564,7.74a1.789,1.789,0,0,1,.584,1.322V23.015a2.133,2.133,0,0,1-2.133,2.133Zm18.483-2.133V9.215L17.878,4.534h-.194V7.021a3.2,3.2,0,0,1-3.2,3.2H9.153a3.2,3.2,0,0,1-3.2-3.2V4.533H4.533V23.015H6.31V18.75a3.2,3.2,0,0,1,3.2-3.2h8.531a3.2,3.2,0,0,1,3.2,3.2v4.265Zm-3.91,0V18.75a1.066,1.066,0,0,0-1.066-1.066H9.509A1.066,1.066,0,0,0,8.442,18.75v4.265ZM8.087,7.021A1.066,1.066,0,0,0,9.153,8.087h5.332a1.066,1.066,0,0,0,1.066-1.066V4.533H8.087Z",
    transform: "translate(-2.4 -2.4)",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSaveIcon);
export default __webpack_public_path__ + "static/media/save-icon.2d4c4482400efe996e21c2b8e5a250e4.svg";
export { ForwardRef as ReactComponent };